export default "__VITE_ASSET__667c23f7__"